module.exports = __webpack_public_path__ + "img/353.530cf8c5.jpg";